interface SeletorQuantidadeProps {
  quantidade: number;
  max: number;
  onChange: (quantidade: number) => void;
}

export default function SeletorQuantidade({
  quantidade,
  max,
  onChange,
}: SeletorQuantidadeProps) {
  const diminuir = () => onChange(Math.max(1, quantidade - 1));
  const aumentar = () => onChange(Math.min(max, quantidade + 1));
  const noMaximo = max > 1 && quantidade >= max;

  return (
    <div className="rounded-[16px] bg-background-50 p-4 shadow-pcard">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-[16px] font-extrabold text-foreground-950">Quantos ingressos?</h2>
        {noMaximo && (
          <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-1 text-[11.5px] font-bold text-foreground-600">
            Máximo de {max} por compra
          </span>
        )}
      </div>

      <div className="mt-3 flex items-center justify-center gap-8">
        <button
          type="button"
          onClick={diminuir}
          disabled={quantidade <= 1}
          aria-label="Diminuir quantidade"
          className="flex h-[52px] w-[52px] cursor-pointer items-center justify-center rounded-full border border-background-300 text-2xl font-medium text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:border-background-200 disabled:text-foreground-300"
        >
          −
        </button>

        <span className="min-w-[56px] text-center text-[32px] font-extrabold leading-none text-foreground-950">
          {quantidade}
        </span>

        <button
          type="button"
          onClick={aumentar}
          disabled={quantidade >= max}
          aria-label="Aumentar quantidade"
          className="flex h-[52px] w-[52px] cursor-pointer items-center justify-center rounded-full border border-background-300 text-2xl font-medium text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:border-background-200 disabled:text-foreground-300"
        >
          +
        </button>
      </div>
    </div>
  );
}